import AppRoute from "models/AppRoute"

const TenantSettingsRoute = new AppRoute({
    route: "/tenant",
    navbar: true,
    authRequired: true,
})

export default TenantSettingsRoute
